import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=b7de8ace&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7de8ace')) {
      api.createRecord('b7de8ace', component.options)
    } else {
      api.reload('b7de8ace', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=b7de8ace&", function () {
      api.rerender('b7de8ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21kKXk9p4rI8L/JS/offershelp.vue"
export default component.exports